import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaPricingResponse } from "../interface/entuba/pricing/IEntubaPricingResponse";
import { IEntubaPricingDetailResponse } from "../interface/entuba/pricing/IEntubaPricingDetailResponse";
import { IEntubaPan } from "../interface/IEntubaPan";

enum EntubaPanServiceEnum {
  getAll = "/",
  getDetail = "",
  start = "/entuba/start",
}

export default class EntubaPanService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/pan");
  }

  public getAll = async (): Promise<IEntubaPricingResponse[]> => await this.GET(EntubaPanServiceEnum.getAll);
  public getDetail = async (id: number): Promise<IEntubaPricingDetailResponse> => await this.GET(`${EntubaPanServiceEnum.getDetail}/${id}`);
  public startEntuba = async (data: IEntubaPan) => await this.POST(EntubaPanServiceEnum.start, data);
}
